import Marionette from "backbone.marionette";

import InsertInstance from "views/instances/insertInstanceView.js";
import InstanceModel from "models/instanceModel.js";

import InstancesTpl from "views/instances/instancesView.ejs";

import CSS from "views/instances/instances.css";

import S from "session/session.js";
import T from "session/token.js";

require('jquery-equalheights');

export default Marionette
    .LayoutView
    .extend({
        initialize: function() {

            $('.content-wrapper').css({ 'margin-left': '230px' });

            this
                .listenTo(S.mApp, "update:instances", function(ev) {
                    this
                        .collection
                        .fetch({
                            data: {
                                page: 1,
                                company: S.companyId
                            },
                            beforeSend: T.useToken
                        });
                });

            this.listenTo(this.collection, "destroy", this.applyView.bind(this));
            this.listenTo(this.collection, "sync", this.applyView.bind(this));
        },
        template: InstancesTpl,
        render: function() {
            $("#loaderContainer").show();

            this
                .collection
                .fetch({
                    data: {
                        page: 1,
                        company: S.companyId
                    },
                    beforeSend: T.useToken
                });

            S
                .userInfo
                .set({ options: S.mainMenu });

        },
        applyView: function() {
            $("#loaderContainer").hide();
            /* this
                .$el
                .html(this.template(this.collection)); */
            this.$el.html(this.template({
                models: this.collection.models,
                lang: this.collection.lang,
                role: S.userInfo.attributes.role
            }));
            _.each(this.collection.models, function(model) {
                var SrcIcon = "files/icons/icon" + model.id;
                if (model.attributes['ext']) {
                    SrcIcon = "files/icons/icon" + model.id + '.' + model.attributes['ext'];
                }
                $("#icon" + model.id).attr("src", SrcIcon);
            });

            // Show usuarios y entornos
            $("a#USERS, a#ENVIRO").parent().show();

            $("body").removeClass().addClass("hold-transition skin-black fixed sidebar-mini");
            $(".main-sidebar").show();

            // Remove active menu items
            $(".sidebar li").removeClass("active");
            $(".sidebar li > ul").removeClass("menu-open");
            // Add active menu items
            $("#ENVIRO").parent().addClass("active");


        },
        events: {
            "click #addInstance": "addInstance",
            "click .instanceItem": "select",
            "click .editInstanceItem": "edit"
        },
        addInstance: function(ev) {
            S.mApp
                .trigger("modal", {
                    view: new InsertInstance({ model: new InstanceModel(), collection: this.collection })
                });
        },
        select: function(ev) {

            S.instanceId = $(ev.target).attr("data-id");
            // window.top.location = "#menu";
            window.top.location = "#planos/planos_1176";
            //window.top.location = "#planos";

        },
        edit: function(ev) {
            var tag = $(ev.target);
            var instanceId = tag.attr("data-id");
            S.mApp
                .trigger("modal", {
                    view: new InsertInstance({
                        model: this
                            .collection
                            .get(instanceId),
                        collection: this.collection
                    })
                });
        }
    });


//////////////////
// WEBPACK FOOTER
// ./app/views/instances/instancesView.js
// module id = 186
// module chunks = 0